function panic() {

    console.log('lifecycle :', 'panic loading scene');
}

export {panic};
